import { Target } from "lucide-react";
import React, { useState, useEffect } from "react";

export default function Header({ band }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const links = [
    /*{ href: "#music", label: "Musiques" },
    { href: "#tour", label: "Concerts" },
    { href: "#photos", label: "Photos" },
    { href: "#videos", label: "Vidéos" },*/
    { href: 'https://www.instagram.com/palladium_off?igsh=d2x1NGYydm12YzVy', label: 'Instagram', target: "_blank" },
    { href: 'https://open.spotify.com/artist/0MyzAsy9H4dOBUr9k494G1?si=fw2ZNyK6Sm6VQa-x55wceQ', label: 'Spotify', target: "_blank" },
    { href: 'https://youtube.com/@palladium6745?si=MHm_Ps0ttVq6ruOR', label: 'YouTube', target: "_blank" },
  ];

  return (
    <header className={`fixed top-0 w-full z-50 bg-black/50 backdrop-blur-md shadow-sm text-white
        transition-all duration-300
        ${visible
          ? "opacity-100 translate-y-0"
          : "md:opacity-0 md:-translate-y-full md:pointer-events-none"
        }
      `}>
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Hamburger mobile + logo */}
        <div className="flex items-center gap-4">
          {/* Hamburger à gauche */}
          <button
            className="md:hidden flex flex-col justify-center items-center w-8 h-8 relative mr-2"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span
              className={`block w-6 h-0.5 bg-white mb-1 transition-transform duration-300 ${
                menuOpen ? "rotate-45 translate-y-1" : ""
              }`}
            ></span>
            <span
              className={`block w-6 h-0.5 bg-white mb-1 transition-opacity duration-300 ${
                menuOpen ? "opacity-0" : ""
              }`}
            ></span>
            <span
              className={`block w-6 h-0.5 bg-white transition-transform duration-300 ${
                menuOpen ? "-rotate-45 -translate-y-2" : ""
              }`}
            ></span>
          </button>

          {/* Logo */}
          <div
            className={`w-12 h-12 rounded overflow-hidden flex items-center justify-center bg-transparent transition-transform duration-500 ${
              menuOpen ? "scale-110" : "scale-100"
            }`}
          >
            <img
              src={`https://api.palladium.rocks/images/${band.logo}`}
              alt={`${band.name} logo`}
              className="w-full h-full object-cover"
            />
          </div>

          {/* Nom du groupe */}
          <div className="hidden md:flex flex-col">
            <h1 className="text-lg font-semibold">{band.name}</h1>
            <p className="text-xs">{band.tagline}</p>
          </div>
        </div>

        {/* Menu desktop */}
        <nav className="hidden md:flex gap-6 items-center text-sm">
          {links.map((link) => (
            <a key={link.href} href={link.href} className="hover:underline" target={link.target}>
              {link.label}
            </a>
          ))}
        </nav>
      </div>

      {/* Menu mobile déroulant */}
      <div
        className={`md:hidden overflow-hidden transition-max-h duration-500 ease-in-out bg-transparent ${
          menuOpen ? "max-h-96" : "max-h-0"
        }`}
      >
        <div className="flex flex-col px-6 py-4 gap-4">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              target={link.target}
              className="text-white text-lg hover:underline"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </header>
  );
}
